import React from 'react';
import { Span } from '@vp/swan';

const localizationContext = React.createContext({
  t: () => {
    return "";
  }
});
const LocalizationsProvider = ({ children, localizations }) => {
  const useLocalizationsValue = {
    t: (key, tokens = {}) => {
      const localizedText = getLocalizationForKey(localizations, key);
      if (!localizedText) {
        console.error(`Localization for key ${key} not found`);
        return key;
      }
      const parts = localizedText.split(/{{\s*(.*?)\s*}}/g);
      const renderedParts = parts.map((part) => tokens[part] || part);
      const isReactNode = renderedParts.some((part) => React.isValidElement(part));
      const renderedPartsWithKeys = isReactNode ? parts.map((part, index) => {
        const value = tokens[part] || part;
        if (React.isValidElement(value)) {
          return React.cloneElement(value, { key: `part-${index}` });
        }
        return /* @__PURE__ */ React.createElement(React.Fragment, { key: `part-${index}` }, value);
      }) : null;
      return isReactNode ? /* @__PURE__ */ React.createElement(Span, null, renderedPartsWithKeys) : renderedParts.join("");
    }
  };
  return /* @__PURE__ */ React.createElement(localizationContext.Provider, { value: useLocalizationsValue }, children);
};
const useLocalization = () => {
  return React.useContext(localizationContext);
};
const getLocalizationForKey = (localizations, path) => {
  return path.split(".").reduce((currentLocalizationObj, pathSegment) => {
    if (currentLocalizationObj && typeof currentLocalizationObj === "object" && pathSegment in currentLocalizationObj) {
      return currentLocalizationObj[pathSegment];
    }
    return void 0;
  }, localizations);
};

export { LocalizationsProvider, localizationContext, useLocalization };
//# sourceMappingURL=src-hooks-useLocalizations.js.map
